import Item from '../item';
import ItemSet from '../item/item-set';
import { ITEM_SET_STATS, ItemSetName } from '../item/item-types';
export type ItemSetTabProps = {
    sets: ItemSetName[],
}

const ItemSetTab: React.FC<ItemSetTabProps> = ({ sets }) => {
    return (
        <div className='item-set-tab'>
            {sets.map(setName => {
                const componentItems = ITEM_SET_STATS[setName].components;

                return (
                    <div className='item-set-entry'>
                        <ItemSet key={setName} itemSetName={setName} enableTooltip={true} />
                        <img height={60} width={40} src={`/resources/menu/menu_arrow.png`} alt='Arrow' />
                        {
                            componentItems && componentItems.map((itemName, idx) => (
                                <Item key={`${setName}-${itemName}-${idx}`} itemName={itemName} />
                            ))
                        }
                        {componentItems?.length === 2 ? <div className='item-set-alignment' /> : undefined}
                    </div>
                )
            })}
        </div >
    );
};

export default ItemSetTab;